import { z } from "zod"

export default z.object({
  name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().optional().nullable(),
  message_text: z.string().min(1),
  consent: z.boolean(),
})
